// Minimal toast — no library. Renders ephemeral div, auto-remove 2s.
export function showToast(message: string) {
    if (typeof document === 'undefined') return;
    const el = document.createElement('div');
    el.textContent = message;
    el.className = 'fixed bottom-6 right-6 z-50 px-4 py-2.5 rounded-lg text-sm';
    el.style.cssText = 'background:#111114;border:1px solid #1f1f23;color:#e4e4e7;box-shadow:0 6px 16px rgba(0,0,0,0.4);animation:slideUp .2s ease-out';
    document.body.appendChild(el);
    setTimeout(() => {
        el.style.opacity = '0';
        el.style.transition = 'opacity .2s';
        setTimeout(() => el.remove(), 200);
    }, 1800);
}
